import { render, staticRenderFns } from "./RoleChangeUsers.vue?vue&type=template&id=02408955&scoped=true"
import script from "./RoleChangeUsers.vue?vue&type=script&lang=ts"
export * from "./RoleChangeUsers.vue?vue&type=script&lang=ts"
import style0 from "./RoleChangeUsers.vue?vue&type=style&index=0&id=02408955&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02408955",
  null
  
)

export default component.exports